import RestError from "./rest_error";

export default class RestAuthenticationError extends RestError {}
